import "./QdsSignatureCard.style.css";
import { QdsSignatureCardProps } from "../QdsSignatures.types";
import { QdsSignatureCardInfo } from "./QdsSignatureCardInfo";
import { QdsSignatureCardActions } from "./QdsSignatureCardActions";
import { QdsStatusEnum } from "../../../entities/IQdsRequest";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../store/auth/AuthSelectors";

export const QdsSignatureCard = (signature: QdsSignatureCardProps) => {
  const { qdsRequest, mode, onClick } = signature;
  const { t } = useTranslation();
  const user = useUser();

  const getStatusInfo = () => {
    if (mode === "approvals") {
      const userId = Number(user?.backEndId);
      const userConsent = qdsRequest?.consents?.find((c) => c.userId === userId);

      if (userConsent?.status === QdsStatusEnum.APPROVED) {
        return { text: t("DOCUMENTS.QDS_APPROVED"), backgroundColor: "#28a745" };
      }

      return { text: t("DOCUMENTS.QDS_PENDING_APPROVAL"), backgroundColor: "#e67e22" };
    }

    if (qdsRequest?.status === QdsStatusEnum.SIGNED) {
      return { text: t("DOCUMENTS.QDS_SIGNED"), backgroundColor: "#28a745" };
    }

    return { text: t("DOCUMENTS.QDS_PENDING"), backgroundColor: "#e67e22" };
  };

  const statusInfo = getStatusInfo();

  return (
    <div className="qdssignature-card qdscursor-pointer" onClick={onClick}>
      <div className="qds-card-main-content">
        <QdsSignatureCardActions {...signature} />
        <QdsSignatureCardInfo {...signature} />
      </div>
      <button
        className="qds-status-button"
        style={{ backgroundColor: statusInfo.backgroundColor }}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        {statusInfo.text}
      </button>
    </div>
  );
};
